export enum Size {
	XL = 'xl',
	LG = 'lg',
	MD = 'md',
	SM = 'sm',
	FULLSCREEN = 'fullScreen',
}
